module.exports = __webpack_public_path__ + "img/thank-you.7ca0dd5d.png";